<section>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 px-0 ">
                <div class="tkt_back" *ngIf="itself">
                    <img class="lazyload" [attr.data-src]="category_image_url+'blog_categories/'+itself.cover_image" src="../../../assets/images/loading.gif" alt=""  />
                    <div class="ticket_bg d-flex  justify-content-center">
                        <div class="ticket_reg">
                            <a routerLink="/registration/wedding-couple" class="ticket_crt_reg">CREATE A REGISTRY</a>
                            <a routerLink="/find-couple" class="ticket_fnd_reg">FIND A REGISTRY</a>
                        </div>
                    </div>
                    <div class="state_page_banner_txt" *ngIf="extraCategoryData && extraCategoryData.length > 0">
                        <div class="container">
                            <div class="top_ten_head">TOP 10 {{itself.name | uppercase}} </div>
                        </div>
                    </div>
                
                </div>
            </div>
        </div>
    </div>
  
    <div class="fq_cat_Listing" *ngFor="let detailcat of extraCategoryData;let i = index">
        <div class="container">
            <div class="row reverse_row_faq">
                <div class="col-12 col-md-7 col-lg-8 fq_list_cnt_dir">
                    <div class="d-flex list_content_cat">
                        <div class="list_fq_num align-self-start">{{extraCategoryData.length-i}}.</div>
                        <div class="sub_list_content">
                            <a href="javascript:void(0);" class="list-fq-heading">{{detailcat.title}}</a>
                            <p class="list-fq-text">
                                {{detailcat.description | appendDollar}}
                            </p>
                            <ng-container *ngIf="detailcat.experience_id > 0 || detailcat.page_url != ''">
                                <button type="button" (click)="navigateToPageUrl(detailcat.page_url, detailcat.experience_slug);">Available on Spur</button>
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-5 col-lg-4 fq_list_img_dir">
                    <div class="faq_img_cat">
    
    
                        <img data-src="{{detailcat.image_url ? detailcat.image_url : ''}}" alt="" src="../../../assets/images/loading.gif" class="lazyload" />
                    </div>
    
                </div>
            </div>
        </div>
    </div>
    <!-- ===============blog list ==================== -->
    <div class="blog_list_section">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h1>ARCHIVE | SPURMINDSET</h1>
                </div>
            </div>

            <div class="row" *ngIf="category_data">
                <div class="col-12 m-auto text-center text-md-left col-md-6  col-lg-4" *ngFor="let cat_data of category_data">
                    <div class="blog_cont_head" >
                        <div class="card" >
                            <a [routerLink]="['/blog-detail/',cat_data.slug]">
                                <img class="lazyload blogImage" [attr.data-src]="category_image_url+'blogs/'+cat_data.image" alt="" src="../../../assets/images/loading.gif">
                            </a>
                            <div class="card-body">
                                <a class="blog__list_title" [routerLink]="['/blog-detail/',cat_data.slug]" title="booking reservation email daily" [innerHTML]="cat_data.name"></a>

                                <div class="blog_data">
                                    <span>by </span>
                                    <span class="author_card">
                                        <a [routerLink]="['/blog-detail/',cat_data.slug]" [innerHTML]="cat_data.author_name"> </a>
                                    </span>
                                    <span> on </span>
                                    <abbr class="blog_time_date" > {{cat_data.created_at | date:'mediumDate'}}</abbr>
                                    <span> in </span>
                                    <span class="blog_category"><a [routerLink]="['/blog-detail/',cat_data.slug]" [innerHTML]="cat_data.category_name">  </a></span>
                                </div>

                                <div class="blog_list_content">
                                   <p [innerHTML]="cat_data.description | appendDollar | wordLimit:[300]"></p> 
                                </div>
                                <div class="post_blog">
                                    <a [routerLink]="['/blog-detail/',cat_data.slug]">Continue Reading</a>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

         
            </div>
            
        </div>
    </div>

    <!-- ====================  artical category ==================== -->

    <div class="artical_wraper">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h2>SPUR ARTICLES BY CATEGORY</h2>
                </div>
            </div>
            <div class='row' *ngIf="other_data">
                <div class="col-12 col-sm-6 col-md-4 col-lg-3" *ngFor="let other_section of other_data">
                    <a [routerLink]="['/category-blog/',other_section.slug]">
                        <figure>
                            <div class="artic_img lazyload"  [attr.data-bg]="category_image_url+'blog_categories/'+other_section.image" [ngStyle]="{'background-image': 'url(' + category_image_url+'blog_categories/'+other_section.image + ')'}"  ></div>
                            <figcaption class="text-center">
                                <a [routerLink]="['/category-blog/',other_section.slug]"  [innerHTML]="other_section.name"></a>
                            </figcaption>
                        </figure>
                    </a>
                </div>
                
            </div>
        </div>
    </div>

</section>
